(function () {
  if (window.WiageotCober) return;
  window.WiageotCober = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealItems = document.querySelectorAll('[data-wg-reveal]');

  if (!reducedMotion && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -7% 0px' });
    revealItems.forEach(function (item) { revealObserver.observe(item); });
  } else {
    revealItems.forEach(function (item) { item.classList.add('is-visible'); });
  }

  function syncHeader() {
    document.body.classList.toggle('wg-header-scrolled', window.scrollY > 24);
  }
  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });

  document.querySelectorAll('[data-wg-custom-header]').forEach(function (header) {
    var toggle = header.querySelector('[data-wg-menu-toggle]');
    var menu = header.querySelector('[data-wg-mobile-menu]');
    var close = header.querySelector('[data-wg-menu-close]');
    var desktopMenus = header.querySelectorAll('.wg-nav-dropdown');

    function setMenu(open) {
      if (!toggle || !menu) return;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.hidden = !open;
      document.documentElement.classList.toggle('wg-menu-open', open);
    }

    if (toggle) toggle.addEventListener('click', function () { setMenu(true); });
    if (close) close.addEventListener('click', function () { setMenu(false); });
    menu && menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { setMenu(false); });
    });

    desktopMenus.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        desktopMenus.forEach(function (other) { if (other !== details) other.open = false; });
      });
    });

    document.addEventListener('click', function (event) {
      if (header.contains(event.target)) return;
      desktopMenus.forEach(function (details) { details.open = false; });
    });
  });

  document.querySelectorAll('[data-wg-slider]').forEach(function (slider) {
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-wg-slide]'));
    var index = 0;
    var timer;
    if (slides.length < 2) return;

    function show(next) {
      slides[index].classList.remove('is-active');
      index = (next + slides.length) % slides.length;
      slides[index].classList.add('is-active');
    }
    function start() {
      if (reducedMotion) return;
      window.clearInterval(timer);
      timer = window.setInterval(function () { show(index + 1); }, 5500);
    }
    slider.querySelectorAll('[data-wg-prev]').forEach(function (button) {
      button.addEventListener('click', function () { show(index - 1); start(); });
    });
    slider.querySelectorAll('[data-wg-next]').forEach(function (button) {
      button.addEventListener('click', function () { show(index + 1); start(); });
    });
    start();
  });

  document.querySelectorAll('[data-wg-tabs]').forEach(function (tabs) {
    var buttons = tabs.querySelectorAll('[data-wg-tab]');
    var panels = tabs.querySelectorAll('[data-wg-panel]');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.getAttribute('data-wg-tab');
        buttons.forEach(function (item) {
          var active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-wg-panel') === target);
        });
      });
    });
  });

  document.querySelectorAll('[data-wg-configurator]').forEach(function (configurator) {
    var options = configurator.querySelectorAll('[data-wg-configuration]');
    var summary = configurator.querySelector('[data-wg-configuration-summary]');
    var image = configurator.querySelector('[data-wg-configuration-image]');
    var productLink = configurator.querySelector('[data-wg-configuration-link]');
    options.forEach(function (option) {
      option.addEventListener('click', function () {
        options.forEach(function (item) {
          var active = item === option;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (summary) summary.textContent = option.getAttribute('data-wg-configuration');
        if (image && option.getAttribute('data-wg-image')) {
          image.src = option.getAttribute('data-wg-image');
          image.alt = option.getAttribute('data-wg-alt') || option.getAttribute('data-wg-configuration');
        }
        if (productLink && option.getAttribute('data-wg-product-url')) {
          productLink.href = option.getAttribute('data-wg-product-url');
        }
      });
    });
  });

  document.querySelectorAll('[data-wg-shop-look]').forEach(function (shopLook) {
    var hotspots = shopLook.querySelectorAll('[data-wg-look-target]');
    var items = shopLook.querySelectorAll('[data-wg-look-item]');

    function activate(target) {
      hotspots.forEach(function (hotspot) {
        hotspot.classList.toggle('is-active', hotspot.getAttribute('data-wg-look-target') === target);
      });
      items.forEach(function (item) {
        item.classList.toggle('is-active', item.getAttribute('data-wg-look-item') === target);
      });
    }

    hotspots.forEach(function (hotspot) {
      hotspot.addEventListener('click', function () {
        var target = hotspot.getAttribute('data-wg-look-target');
        activate(target);
        var item = shopLook.querySelector('[data-wg-look-item="' + target + '"]');
        if (item) item.focus({ preventScroll: true });
      });
    });

    items.forEach(function (item) {
      ['mouseenter', 'focus'].forEach(function (eventName) {
        item.addEventListener(eventName, function () {
          activate(item.getAttribute('data-wg-look-item'));
        });
      });
    });
  });

  document.querySelectorAll('[data-wg-product-config]').forEach(function (configurator) {
    var data = configurator.querySelector('[data-wg-variant-data]');
    var variantInput = configurator.querySelector('[data-wg-variant-id]');
    var price = configurator.querySelector('[data-wg-product-price]');
    var addButton = configurator.querySelector('[data-wg-add-button]');
    if (!data || !variantInput) return;

    var variants;
    try { variants = JSON.parse(data.textContent); } catch (error) { return; }

    function selectedOptions() {
      return Array.prototype.map.call(configurator.querySelectorAll('[data-wg-option-group]'), function (group) {
        var selected = group.querySelector('input:checked');
        return selected ? selected.value : '';
      });
    }

    function syncVariant() {
      var selected = selectedOptions();
      var variant = variants.find(function (item) {
        return item.options.length === selected.length && item.options.every(function (value, index) { return value === selected[index]; });
      });
      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'Unavailable';
        }
        return;
      }
      variantInput.value = variant.id;
      if (price) price.textContent = variant.price;
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    }

    configurator.querySelectorAll('[data-wg-option-value]').forEach(function (input) {
      input.addEventListener('change', syncVariant);
    });
  });

  document.querySelectorAll('[data-wg-pdp-gallery]').forEach(function (gallery) {
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-wg-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-wg-gallery-thumb]'));
    var count = gallery.querySelector('[data-wg-gallery-count]');
    var index = 0;
    if (!slides.length) return;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === index);
      });
      thumbs.forEach(function (thumb, thumbIndex) {
        thumb.classList.toggle('is-active', thumbIndex === index);
        thumb.setAttribute('aria-current', thumbIndex === index ? 'true' : 'false');
      });
      if (thumbs[index]) thumbs[index].scrollIntoView({ block: 'nearest' });
      if (count) count.textContent = (index + 1) + ' / ' + slides.length;
    }

    thumbs.forEach(function (thumb, thumbIndex) {
      thumb.addEventListener('click', function () { show(thumbIndex); });
    });
    var previous = gallery.querySelector('[data-wg-gallery-prev]');
    var next = gallery.querySelector('[data-wg-gallery-next]');
    if (previous) previous.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
  });

  document.querySelectorAll('.wg-pdp__top').forEach(function (productTop) {
    var galleryStage = productTop.querySelector('.wg-pdp-gallery__stage');
    var buybox = productTop.querySelector('.wg-pdp-buybox');
    var desktop = window.matchMedia('(min-width: 990px)');
    if (!galleryStage || !buybox) return;

    function syncProductPanelHeight() {
      if (!desktop.matches) {
        buybox.style.removeProperty('--wg-pdp-panel-height');
        return;
      }
      buybox.style.setProperty('--wg-pdp-panel-height', Math.round(galleryStage.getBoundingClientRect().height) + 'px');
    }

    syncProductPanelHeight();
    window.addEventListener('resize', syncProductPanelHeight, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(syncProductPanelHeight).observe(galleryStage);
    }
  });

  document.querySelectorAll('[data-wg-choice-group]').forEach(function (group) {
    var choices = group.querySelectorAll('[data-wg-choice]');
    var summary = group.querySelector('[data-wg-choice-summary]');
    choices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        choices.forEach(function (item) {
          var active = item === choice;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (summary) summary.textContent = choice.getAttribute('data-wg-choice');
      });
    });
  });

  document.querySelectorAll('[data-wg-swatch-group]').forEach(function (group) {
    var swatches = group.querySelectorAll('[data-wg-swatch]');
    var summary = group.closest('.wg-product-option').querySelector('[data-wg-swatch-summary]');
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (item) {
          var active = item === swatch;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (summary) summary.textContent = swatch.getAttribute('data-wg-swatch');
      });
    });
  });

  if (!reducedMotion) {
    var parallaxItems = document.querySelectorAll('[data-wg-parallax]');
    var ticking = false;
    function updateParallax() {
      parallaxItems.forEach(function (item) {
        var rect = item.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * -0.055;
        item.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0) scale(1.08)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    }, { passive: true });
    updateParallax();
  }
})();
